_pm_pid = "EF9BCAEE0565281C";

function _pm_geturlparm(parmname) {
  var regex = new RegExp("[\\?&]" + parmname + "=([^&#]*)");
  var result = regex.exec(location.search);
  var ret =
    result === null ? "" : decodeURIComponent(result[1].replace(/\+/g, " "));

  return ret;
}

function _pm_getcookie(cookiename) {
  cookiename += "=";
  if (document.cookie.indexOf(cookiename) != -1) {
    var idxofSource = document.cookie.indexOf(cookiename) + cookiename.length;
    var idxofEnd = document.cookie.indexOf(";", idxofSource);
    var cookval = "";
    if (idxofEnd == -1) {
      cookval = document.cookie.substr(idxofSource);
    } else {
      cookval = document.cookie.substr(idxofSource, idxofEnd - idxofSource);
    }
    if (cookval.length != 0) {
      return cookval;
    } else {
      return null;
    }
  }
}

function _pm_getGa4SessionId() {
  const cookie = document.cookie.split(";").filter(function (cookie) {
    return cookie.indexOf("_ga_") !== -1;
  })[0];
  return cookie ? cookie.split(".")[2] : null;
}

function _pm_getGa4SessionCount() {
  const cookie = document.cookie.split(";").filter(function (cookie) {
    return cookie.indexOf("_ga_") !== -1;
  })[0];
  return cookie ? cookie.split(".")[3] : null;
}

function _pm_getStoredTPTrack() {
  var ret = _pm_getcookie("pmTPTrack");
  if (null != ret && ret.length > 0) {
    ret = JSON.parse(decodeURIComponent(ret));
  } else {
    ret = {
      v: 0,
      gclid: null,
      gacid: null,
      gacid_source: null,
      fbp: null,
      fbc: null,
      firstvisit: null,
    };
  }

  return ret;
}

function _pm_storeTPTrack(tptrack) {
  var _pm_old_tpTrackCookVal = _pm_getcookie("pmTPTrack");

  var _pm_tpTrackCookVal = encodeURIComponent(JSON.stringify(tptrack));

  if (_pm_old_tpTrackCookVal != _pm_tpTrackCookVal) {
    tptrack.v++;
    _pm_tpTrackCookVal = encodeURIComponent(JSON.stringify(tptrack));
  }
  document.cookie = "pmTPTrack=" + _pm_tpTrackCookVal + "; path=/";
}

function _pm_buildTPURL(carttoken, checkoutid) {
  var _pm_curPMTPTrack = _pm_getStoredTPTrack();

  var u =
    "https://my.profitmetrics.io/ss/shopify.php?v=1&pid=" +
    encodeURIComponent(_pm_pid);

  if (null != carttoken) {
    u += "&cart_token=" + encodeURIComponent(carttoken);
  }

  if (null != checkoutid) {
    u += "&checkout_id=" + encodeURIComponent(checkoutid);
  }

  if (null != _pm_curPMTPTrack.gclid) {
    u += "&gclid=" + encodeURIComponent(_pm_curPMTPTrack.gclid);
  }

  if (null != _pm_curPMTPTrack.gacid) {
    u += "&gacid=" + encodeURIComponent(_pm_curPMTPTrack.gacid);
    u += "&gacid_source=" + encodeURIComponent(_pm_curPMTPTrack.gacid_source);
  }

  if (null != _pm_curPMTPTrack.fbp) {
    u += "&fbp=" + encodeURIComponent(_pm_curPMTPTrack.fbp);
  }

  if (null != _pm_curPMTPTrack.fbc) {
    u += "&fbc=" + encodeURIComponent(_pm_curPMTPTrack.fbc);
  }

  if (null != _pm_curPMTPTrack.firstvisit) {
    u +=
      "&t=" + encodeURIComponent(JSON.stringify(_pm_curPMTPTrack.firstvisit));
  }

  if (_pm_curPMTPTrack.gbraid) {
    u += "&gbraid=" + encodeURIComponent(_pm_curPMTPTrack.gbraid);
  }

  if (_pm_curPMTPTrack.wbraid) {
    u += "&wbraid=" + encodeURIComponent(_pm_curPMTPTrack.wbraid);
  }

  if (_pm_curPMTPTrack.ga4SessionId) {
    u += "&ga4_sessionid=" + encodeURIComponent(_pm_curPMTPTrack.ga4SessionId);
  }

  if (_pm_curPMTPTrack.ga4SessionCount) {
    u +=
      "&ga4_sessioncount=" +
      encodeURIComponent(_pm_curPMTPTrack.ga4SessionCount);
  }

  return u;
}

function _pm_sendTPTrack(carttoken, checkoutid) {
  var u = _pm_buildTPURL(carttoken, checkoutid);

  var doSend = true;
  try {
    var botAgents = [
      // taken 2022-11-11
      "AdsBot-Google",
      "AdsBot-Google-Mobile",
      "Googlebot",
      "Storebot-Google",
      "APIs-Google",
      "Mediapartners-Google",
      "FeedFetcher-Google",
      "Google-Read-Aloud",
      "DuplexWeb-Google",
      "Google Favicon",
      "googleweblight",
      "Pinterestbot",
      "AhrefsSiteAudit",
      "AhrefsBot",
      "Seekport Crawler",
      "DuckDuckBot",
      "PingdomPageSpeed",
      "pingbot",
      "YandexAccessibilityBot",
      "adidxbot",
      "bingbot",
      "SMTBot",
      "HubSpot Crawler",
      "e.ventures Investment Crawler",
      "Cincraw",
      "Facebot",
      "Twitterbot",
      "Jooblebot",
      "YisouSpider",
      "YandexMetrika",
      "Applebot",
      "PagePeeker",
      "Linespider",
      "proximic",
      "Algolia Crawler Renderscript",
      "PetalBot",
      "SEOFeedback_WebCrawler",
      "oBot",
      "Impact Radius Compliance Bot",
      "Cocolyzebot",
      "nlnbot",
      "SemrushBot-SA",
      "Bytespider",
      "RyteBot",
      "BrandVeritySpider",
      "ethical-bugbot",
      "Screaming Frog SEO Spider",
      "BublupBot",
      "bitlybot",
      "Better Uptime Bot",
      "KargoBot-Artemis-Mobile",
      "YandexVideoParser",
      "DotBot",
      "BLEXBot",
      "CheckMarkNetwork",
      "MegaIndex.ru",
      "Baiduspider",
      "SurdotlyBot",
      "Taboolabot",
      "SiteScoreBot",
      "StatusCake_Pagespeed_Indev",
      "www.facebook.com/externalhit_uatext.php",
      "+http://yandex.com/bots",
      "YandexBot",
      "LinkedInBot",
      "+https://intelx.io",
      "+https://www.seokicks.de/robot.html",
      "SEOkicks;",
      "ZoominfoBot",
      "BingPreview",
      "Morningscore",
      "heritrix",
      "http://tech.quickpay.net/api/callback",
      "CookieInformationScanner",
      "MJ12bot",
      "KlarnaBot-PriceWatcher",
      "HeadlessChrome",
      "Barkrowler",
    ];

    const userAgent = navigator.userAgent.toLowerCase();
    const isBot = botAgents.some(
      (v) => userAgent.indexOf(v.toLowerCase()) >= 0
    );

    if (isBot == true) {
      doSend = false;
    }
  } catch (ee) {}

  try {
    const dedupUrl = u;
    const lastSentTpUrl = localStorage.getItem("_pm_dedup_tpurl");

    const isDup = lastSentTpUrl != null && lastSentTpUrl == dedupUrl;

    if (!isDup) {
      localStorage.setItem("_pm_dedup_tpurl", dedupUrl);
    }

    if (isDup == true) {
      doSend = false;
    }
  } catch (ee) {}

  if (doSend) {
    fetch(u);
  }
}

//////////////////////

var _pm_curPMTPTrack = _pm_getStoredTPTrack();

if (_pm_curPMTPTrack.fbc == null) {
  var _fbclid = _pm_geturlparm("fbclid");
  if (_fbclid != "") {
    _pm_curPMTPTrack.fbc =
      "fb.1." + String((new Date() / 1e3) | 0) + "." + _fbclid;
  }
}

var _pm_newGclid = _pm_geturlparm("gclid");
if (_pm_newGclid != "") {
  _pm_curPMTPTrack.gclid = _pm_newGclid;
}

var _pm_newFBC = _pm_getcookie("_fbc");
if (null != _pm_newFBC && _pm_curPMTPTrack.fbc != _pm_newFBC) {
  _pm_curPMTPTrack.fbc = _pm_newFBC;
}

var _pm_newFBP = _pm_getcookie("_fbp");
if (null != _pm_newFBP && _pm_curPMTPTrack.fbp != _pm_newFBP) {
  _pm_curPMTPTrack.fbp = _pm_newFBP;
}

var _pm_newGacid = _pm_getcookie("_ga");
if (
  null != _pm_newGacid &&
  _pm_curPMTPTrack.gacid_source != "gatracker" &&
  _pm_curPMTPTrack.gacid != _pm_newGacid
) {
  _pm_curPMTPTrack.gacid = _pm_newGacid;
  _pm_curPMTPTrack.gacid_source = "gacookie";
}

var _pm_gbraid = _pm_geturlparm("gbraid");
if (_pm_gbraid != "") {
  _pm_curPMTPTrack.gbraid = _pm_gbraid;
  _pm_curPMTPTrack.timestamp = (new Date() / 1e3) | 0;
}

var _pm_wbraid = _pm_geturlparm("wbraid");
if (_pm_wbraid != "") {
  _pm_curPMTPTrack.wbraid = _pm_wbraid;
  _pm_curPMTPTrack.timestamp = (new Date() / 1e3) | 0;
}

var _pm_ga4SessionId = _pm_getGa4SessionId();
if (_pm_ga4SessionId) {
  _pm_curPMTPTrack.ga4SessionId = _pm_ga4SessionId;
  _pm_curPMTPTrack.timestamp = (new Date() / 1e3) | 0;
}

var _pm_ga4SessionCount = _pm_getGa4SessionCount();
if (_pm_ga4SessionCount) {
  _pm_curPMTPTrack.ga4SessionCount = _pm_ga4SessionCount;
  _pm_curPMTPTrack.timestamp = (new Date() / 1e3) | 0;
}

if (_pm_curPMTPTrack.firstvisit == null) {
  var utmSource = _pm_geturlparm("utm_source");
  var utmCampaign = _pm_geturlparm("utm_campaign");
  var utmMedium = _pm_geturlparm("utm_medium");

  var httpReferrer = document.referrer;
  var httpReferrerLength = httpReferrer.length;

  httpReferrer = httpReferrer.substr(0, 2000);

  var landingPage = null;
  var landingPageLength = 0;
  try {
    landingPage = window.location.href
      .toString()
      .split(window.location.host)[1];
    landingPageLength = landingPage.length;
    landingPage = landingPage.substr(0, 2000);
  } catch (ee) {}

  var pmVisitSource = {
    utm_source: utmSource.substr(0, 100),
    utm_campaign: utmCampaign.substr(0, 100),
    utm_medium: utmMedium.substr(0, 100),
    http_referrer: httpReferrer,
    http_referrer_length: httpReferrerLength,
    landingpage: landingPage,
    landingpage_length: landingPageLength,
    time: (new Date() / 1e3) | 0,
  };

  var pmVisitSourceCookval = encodeURIComponent(JSON.stringify(pmVisitSource));
  if (pmVisitSourceCookval.length > 4000) {
    pmVisitSource.http_referrer = pmVisitSource.http_referrer.substr(0, 1000);
    if (null != pmVisitSource.landingpage) {
      pmVisitSource.landingpage = pmVisitSource.landingpage.substr(0, 1000);
    }
    pmVisitSourceCookval = encodeURIComponent(JSON.stringify(pmVisitSource));
  }

  if (pmVisitSourceCookval.length > 4000) {
    pmVisitSource = {
      error: "too long",
      time: (new Date() / 1e3) | 0,
    };
  }
  _pm_curPMTPTrack.firstvisit = pmVisitSource;
}

_pm_storeTPTrack(_pm_curPMTPTrack);

function _pm_getGacidFromTracker() {
  if (typeof ga == "function") {
    try {
      ga(function (tracker) {
        var gacid = tracker.get("clientId");
        if (null != gacid) {
          var _pm_curPMTPTrack = _pm_getStoredTPTrack();
          if (_pm_curPMTPTrack.gacid != gacid) {
            _pm_curPMTPTrack.gacid = gacid;
            _pm_curPMTPTrack.gacid_source = "gatracker";

            _pm_storeTPTrack(_pm_curPMTPTrack);
          }
        }
      });
    } catch (eee) {}
  } else {
    setTimeout(_pm_getGacidFromTracker, 100);
  }
}
_pm_getGacidFromTracker();
// ======

function _pm_ensureCart() {
  fetch("/cart/update.js", {
    method: "post",
    body: "attributes[__profitmetrics_ignore]=ignore",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  })
    .then((res) => {
      return res.json();
    })
    .then((cart) => {
      _pm_sendTPTrack(cart.token);

      if (
        null == cart.attributes.__profitmetrics_ct ||
        cart.token != cart.attributes.__profitmetrics_ct
      ) {
        fetch("/cart/update.js", {
          method: "post",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: "attributes[__profitmetrics_ct]=" + cart.token,
        });
      }
    });
}

_pm_ensureCart();
